export default "__VITE_ASSET__C44Bihmp__"